import { PRODUCT_SLUGS, QUEST_SLUGS } from 'utils/constants/products';

import { LineItem } from '../types';

/**
 * Validate if a product belongs to Quest based on its slug
 * @param slug
 * @returns
 */
export const isQuestProduct = (slug: string): boolean =>
  QUEST_SLUGS.includes(slug);

export const QUEST_TAG = 'In-person test';

export const sort360OrderLineItems = (lineItems: LineItem[]) =>
  lineItems.sort((a, b) => {
    const aIs360 =
      a.product_sku === PRODUCT_SLUGS.EVERLYWELL_360_FEMALE ||
      a.product_sku === PRODUCT_SLUGS.EVERLYWELL_360_MALE;
    const bIs360 =
      b.product_sku === PRODUCT_SLUGS.EVERLYWELL_360_FEMALE ||
      b.product_sku === PRODUCT_SLUGS.EVERLYWELL_360_MALE;
    return aIs360 && !bIs360 ? -1 : !aIs360 && bIs360 ? 1 : 0;
  });
